import { intl } from '@/intl'
import { durationUtils } from '@/server-data'

import { NullValue } from './NullValue'

interface Props {
  isNull?: (value: number) => boolean
  format?: durationUtils.TimeDurationFormats
  children: number
}

function defaultIsNull(value: number) {
  return value === 0
}

export function DurationValue(props: Props) {
  const { children, isNull = defaultIsNull, format = 'SHORT' } = props

  return isNull(children) ? (
    <NullValue />
  ) : (
    durationUtils.formatSeconds(intl.translate)(children, format)
  )
}
